import React from "react";
import { Box, Button, Container, Grid, Link, Typography } from "@mui/material";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPhone, faLocationDot, faClock, faArrowUpRightFromSquare } from "@fortawesome/free-solid-svg-icons";
import { faWhatsapp } from "@fortawesome/free-brands-svg-icons";

export const Contacto = () => {
  return (
    <section id="contacto">
      <Container sx={{ py: { xs: 5, md: 7 } }}>
        <Box sx={{ maxWidth: "700px", mx: "auto", textAlign: "center", mb: 4.5 }}>
          <Box
            sx={{
              display: "inline-flex",
              alignItems: "center",
              gap: 1,
              px: 2,
              py: 0.6,
              borderRadius: "30px",
              backgroundColor: "rgba(212, 175, 55, 0.1)",
              border: "1px solid rgba(212, 175, 55, 0.25)",
              color: "#9E7736",
              fontSize: "0.75rem",
              fontWeight: 700,
              textTransform: "uppercase",
              letterSpacing: "0.1em",
              mb: 2,
            }}
          >
            <span>✦</span> Visítanos & Reserva
          </Box>
          <Typography
            variant="h2"
            sx={{
              mb: 1.5,
              fontFamily: "'Plus Jakarta Sans', sans-serif",
              color: "#1C1612",
              fontWeight: 700,
              fontSize: { xs: "1.85rem", md: "2.35rem" },
              letterSpacing: "-0.02em",
            }}
          >
            Contacto & Ubicación
          </Typography>
          <Typography variant="body1" sx={{ color: "#68594F", fontSize: "0.95rem", lineHeight: 1.7 }}>
            Encuéntranos en el corazón de Barcelona, a solo unos pasos de las paradas de metro de Entença y Rocafort.
          </Typography>
        </Box>

        <Grid container spacing={4} alignItems="stretch">
          {/* Free Styled Map */}
          <Grid item xs={12} md={7}>
            <Box
              sx={{
                width: "100%",
                height: { xs: "340px", md: "100%" },
                minHeight: { md: "460px" },
                borderRadius: "24px",
                overflow: "hidden",
                border: "1px solid rgba(158, 119, 54, 0.18)",
                boxShadow: "0 10px 30px -10px rgba(45, 33, 26, 0.08)",
                position: "relative",
                backgroundColor: "#FAF8F5",
              }}
            >
              {/* Isolated Leaflet Map iframe */}
              <iframe
                src="/map.html"
                width="100%"
                height="100%"
                style={{
                  border: 0,
                  display: "block",
                  width: "100%",
                  height: "100%",
                  minHeight: "340px",
                }}
                allowFullScreen={true}
                title="Ubicación Hua Hao Yue Yuan"
              />

              {/* Floating Badge in Map */}
              <Box
                sx={{
                  position: "absolute",
                  top: 16,
                  left: 16,
                  zIndex: 10,
                  backgroundColor: "rgba(250, 248, 245, 0.92)",
                  backdropFilter: "blur(12px)",
                  border: "1px solid rgba(158, 119, 54, 0.25)",
                  borderRadius: "20px",
                  px: 1.8,
                  py: 0.8,
                  display: "flex",
                  alignItems: "center",
                  gap: 1,
                  boxShadow: "0 4px 14px rgba(45, 33, 26, 0.08)",
                  pointerEvents: "none",
                }}
              >
                <FontAwesomeIcon icon={faLocationDot} size="xs" color="#9E7736" />
                <span style={{ color: "#1C1612", fontWeight: 700, fontSize: "0.82rem" }}>
                  Carrer València 57
                </span>
              </Box>

              {/* Direct Google Maps link */}
              <Box
                sx={{
                  position: "absolute",
                  bottom: 16,
                  left: 16,
                  zIndex: 10,
                }}
              >
                <Button
                  href="https://www.google.com/maps/dir/?api=1&destination=Carrer+Valencia+57+08015+Barcelona"
                  target="_blank"
                  rel="noopener noreferrer"
                  variant="contained"
                  size="small"
                  startIcon={<FontAwesomeIcon icon={faArrowUpRightFromSquare} />}
                  sx={{
                    background: "rgba(255, 255, 255, 0.92)",
                    backdropFilter: "blur(10px)",
                    color: "#1C1612",
                    borderColor: "rgba(158, 119, 54, 0.3)",
                    border: "1px solid",
                    borderRadius: "16px",
                    fontWeight: 700,
                    fontSize: "0.76rem",
                    px: 1.6,
                    py: 0.6,
                    textTransform: "none",
                    boxShadow: "0 2px 10px rgba(45, 33, 26, 0.08)",
                    "&:hover": {
                      background: "#FFFFFF",
                      color: "#9E7736",
                      borderColor: "#9E7736",
                    },
                  }}
                >
                  Abrir en Google Maps
                </Button>
              </Box>
            </Box>
          </Grid>

          {/* Tarjeta de Información */}
          <Grid item xs={12} md={5}>
            <Box
              sx={{
                backgroundColor: "#FFFFFF",
                border: "1px solid rgba(158, 119, 54, 0.16)",
                borderRadius: "24px",
                p: { xs: 3.5, sm: 4.5 },
                height: "100%",
                display: "flex",
                flexDirection: "column",
                justifyContent: "space-between",
                gap: 3.5,
                boxShadow: "0 10px 30px -10px rgba(45, 33, 26, 0.06)",
              }}
            >
              {/* Horario */}
              <Box>
                <Typography
                  variant="h6"
                  sx={{
                    fontFamily: "'Plus Jakarta Sans', sans-serif",
                    color: "#1C1612",
                    fontWeight: 700,
                    fontSize: "1.1rem",
                    mb: 1.5,
                    display: "flex",
                    alignItems: "center",
                    gap: 1.2,
                  }}
                >
                  <Box
                    sx={{
                      width: 32,
                      height: 32,
                      borderRadius: "50%",
                      backgroundColor: "rgba(212, 175, 55, 0.12)",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    <FontAwesomeIcon icon={faClock} size="xs" color="#9E7736" />
                  </Box>
                  Horario
                </Typography>
                <Box sx={{ display: "flex", flexDirection: "column", gap: 1 }}>
                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "space-between",
                      backgroundColor: "#FAF8F5",
                      border: "1px solid rgba(158, 119, 54, 0.1)",
                      px: 2,
                      py: 1.1,
                      borderRadius: "10px",
                      fontSize: "0.86rem",
                      fontWeight: 600,
                      color: "#4A392F",
                    }}
                  >
                    <span>LUNES - SÁBADO</span>
                    <span style={{ color: "#9E7736" }}>9:30 - 21:30</span>
                  </Box>
                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "space-between",
                      backgroundColor: "#FAF8F5",
                      border: "1px solid rgba(158, 119, 54, 0.1)",
                      px: 2,
                      py: 1.1,
                      borderRadius: "10px",
                      fontSize: "0.86rem",
                      fontWeight: 600,
                      color: "#4A392F",
                    }}
                  >
                    <span>DOMINGO</span>
                    <span style={{ color: "#9E7736" }}>10:30 - 20:30</span>
                  </Box>
                </Box>
              </Box>

              {/* Dónde estamos */}
              <Box>
                <Typography
                  variant="h6"
                  sx={{
                    fontFamily: "'Plus Jakarta Sans', sans-serif",
                    color: "#1C1612",
                    fontWeight: 700,
                    fontSize: "1.1rem",
                    mb: 1.5,
                    display: "flex",
                    alignItems: "center",
                    gap: 1.2,
                  }}
                >
                  <Box
                    sx={{
                      width: 32,
                      height: 32,
                      borderRadius: "50%",
                      backgroundColor: "rgba(212, 175, 55, 0.12)",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    <FontAwesomeIcon icon={faLocationDot} size="xs" color="#9E7736" />
                  </Box>
                  Dónde estamos
                </Typography>
                <Typography sx={{ color: "#1C1612", fontWeight: 700, fontSize: "0.95rem", mb: 0.5 }}>
                  Carrer Valencia 57, Barcelona
                </Typography>
                <Typography sx={{ color: "#68594F", fontSize: "0.86rem", mb: 1 }}>
                  Cerca del metro de Rocafort (L1) y Entença (L5)
                </Typography>
                <Link
                  href="https://www.google.com/maps/dir/?api=1&destination=Carrer+Valencia+57+08015+Barcelona"
                  target="_blank"
                  rel="noopener noreferrer"
                  sx={{
                    color: "#9E7736",
                    fontWeight: 700,
                    fontSize: "0.85rem",
                    textDecoration: "none",
                    display: "inline-flex",
                    alignItems: "center",
                    gap: 0.5,
                    "&:hover": { textDecoration: "underline" },
                  }}
                >
                  Cómo llegar en Google Maps →
                </Link>
              </Box>

              {/* Teléfono y Reservas */}
              <Box>
                <Typography
                  variant="h6"
                  sx={{
                    fontFamily: "'Plus Jakarta Sans', sans-serif",
                    color: "#1C1612",
                    fontWeight: 700,
                    fontSize: "1.1rem",
                    mb: 1.5,
                    display: "flex",
                    alignItems: "center",
                    gap: 1.2,
                  }}
                >
                  <Box
                    sx={{
                      width: 32,
                      height: 32,
                      borderRadius: "50%",
                      backgroundColor: "rgba(212, 175, 55, 0.12)",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    <FontAwesomeIcon icon={faPhone} size="xs" color="#9E7736" />
                  </Box>
                  Teléfono y Reservas
                </Typography>

                <Box sx={{ display: "flex", flexDirection: "column", gap: 1.5 }}>
                  {/* Fila 1 */}
                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "space-between",
                      backgroundColor: "#FAF8F5",
                      border: "1px solid rgba(158, 119, 54, 0.12)",
                      p: 1.5,
                      borderRadius: "14px",
                    }}
                  >
                    <Typography sx={{ fontWeight: 700, color: "#1C1612", fontSize: "0.95rem" }}>
                      605 245 681
                    </Typography>
                    <Box sx={{ display: "flex", gap: 1 }}>
                      <Button
                        href="tel:+34605245681"
                        variant="outlined"
                        size="small"
                        sx={{
                          borderColor: "rgba(158, 119, 54, 0.35)",
                          color: "#9E7736",
                          backgroundColor: "#FFFFFF",
                          borderRadius: "20px",
                          fontWeight: 700,
                          fontSize: "0.75rem",
                          px: 1.6,
                          textTransform: "none",
                          "&:hover": { backgroundColor: "rgba(212, 175, 55, 0.1)" },
                        }}
                      >
                        Llamar
                      </Button>
                      <Button
                        href="https://wa.link/kffk9v"
                        target="_blank"
                        rel="noopener noreferrer"
                        variant="contained"
                        size="small"
                        startIcon={<FontAwesomeIcon icon={faWhatsapp} />}
                        sx={{
                          background: "linear-gradient(135deg, #DFBA73 0%, #C5A059 50%, #9E7736 100%)",
                          color: "#1C1612",
                          borderRadius: "20px",
                          fontWeight: 700,
                          fontSize: "0.75rem",
                          px: 1.8,
                          textTransform: "none",
                          boxShadow: "0 2px 10px rgba(158, 119, 54, 0.25)",
                          "&:hover": {
                            background: "linear-gradient(135deg, #E6C787 0%, #B89248 50%, #8E6A26 100%)",
                          },
                        }}
                      >
                        WhatsApp
                      </Button>
                    </Box>
                  </Box>

                  {/* Fila 2 */}
                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "space-between",
                      backgroundColor: "#FAF8F5",
                      border: "1px solid rgba(158, 119, 54, 0.12)",
                      p: 1.5,
                      borderRadius: "14px",
                    }}
                  >
                    <Typography sx={{ fontWeight: 700, color: "#1C1612", fontSize: "0.95rem" }}>
                      931 050 063
                    </Typography>
                    <Button
                      href="tel:+34931050063"
                      variant="outlined"
                      size="small"
                      sx={{
                        borderColor: "rgba(158, 119, 54, 0.35)",
                        color: "#9E7736",
                        backgroundColor: "#FFFFFF",
                        borderRadius: "20px",
                        fontWeight: 700,
                        fontSize: "0.75rem",
                        px: 1.6,
                        textTransform: "none",
                        "&:hover": { backgroundColor: "rgba(212, 175, 55, 0.1)" },
                      }}
                    >
                      Llamar
                    </Button>
                  </Box>
                </Box>
              </Box>
            </Box>
          </Grid>
        </Grid>
      </Container>
    </section>
  );
};


